// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".body div[data-v-768cb740]:not(:last-of-type){padding-bottom:15px}.body .retained-machine[data-v-768cb740]{display:flex;flex-direction:column}", ""]);
// Exports
module.exports = exports;
